import symbolPrimary from "@/assets/img/brand/symbolPrimary_cropped.svg";
import symbolPrimaryDark from "@/assets/img/brand/symbolPrimaryDark_cropped.svg";
import logoPrimary from "@/assets/img/brand/logoPrimary_cropped.svg";
import logoPrimaryDark from "@/assets/img/brand/logoPrimaryDark_cropped.svg";
import { CSSProperties } from "react";
import { classNames } from "@/utils/classNames";
import { useTranslation, useWhitelabel } from "@/stores/RootStoreContext";
import { Icon } from "./Icon";
import { TMessage } from "@/i18n/tt";

export type LogoProps = {
  linkUrl: string;
  full?: boolean;
  className?: string;
  tooltip?: TMessage;
  variant?: "default" | "back-button";
};

function LogoImg({
  full,
  height,
  className,
}: {
  full?: boolean;
  height: number;
  className?: string;
}) {
  const whitelabel = useWhitelabel();
  if (whitelabel) {
    return (
      <img
        src={`/api/whitelabel/logo/${whitelabel.logoId}`}
        alt="dCompany"
        style={{ height }}
        className={className}
      />
    );
  }
  return <DcompanyLogoImg full={full} style={{ height }} className={className} />;
}

export function DcompanyLogoImg({
  full,
  style,
  className,
}: {
  full?: boolean;
  style?: CSSProperties;
  className?: string;
}) {
  return (
    <>
      <img
        src={full ? logoPrimary : symbolPrimary}
        alt="dCompany"
        style={style}
        className={classNames("hide-on-dark", className)}
      />
      <img
        src={full ? logoPrimaryDark : symbolPrimaryDark}
        alt="dCompany"
        style={style}
        className={classNames("show-on-dark", className)}
      />
    </>
  );
}

export function Logo(props: LogoProps) {
  const { t } = useTranslation();
  const height = props.full ? 34 : props.variant === "back-button" ? 20 : 24;
  const tooltip = props.tooltip ? t(props.tooltip) : undefined;

  switch (props.variant) {
    case "back-button":
      return (
        <a
          href={props.linkUrl}
          className={classNames(
            "flex",
            "flex-none",
            "p-2",
            "text-base",
            "rounded-sm",
            "border",
            "border-gray",
            "color-default",
            "bg-primary-contrast",
            "hover:border-primary",
            "group",
            "relative",
            props.className,
          )}
          data-tooltip={tooltip}
        >
          <LogoImg full={props.full} height={height} className={"visible group-hover:invisible"} />
          <div className="invisible group-hover:visible flex absolute inset-0 items-center justify-center">
            <Icon name="caret-left" color="default" />
          </div>
        </a>
      );
    default:
      return (
        <a
          href={props.linkUrl}
          className={classNames("flex-none", props.className)}
          data-tooltip={tooltip}
        >
          <LogoImg full={props.full} height={height} />
        </a>
      );
  }
}
